__turbopack_context__.v({
  "container": "HtM3oa_container",
  "container__hide": "HtM3oa_container__hide",
  "container__story": "HtM3oa_container__story",
  "content": "HtM3oa_content",
  "content__hide": "HtM3oa_content__hide",
  "header": "HtM3oa_header",
  "shimmer": "HtM3oa_shimmer",
  "text-bar-sweep": "HtM3oa_text-bar-sweep",
  "title": "HtM3oa_title",
});
